export const locationSearch = async (query:string) => {
  // Location Input
  let geocodeEndpoint = `https://maps.googleapis.com/maps/api/geocode/json?address=${query}&key=AIzaSyDu38iTBz3xKFM8-xnluvYvzuPNFR6fylc`;
  try {
    const res = await fetch(geocodeEndpoint);
    const data = await res.json();
    return data?.results[0]?.geometry?.location as google.maps.LatLngLiteral | undefined;
  } catch (e) {
    console.error(`locationSearch error ${e.message}`, e);
  }
};
